module.exports = __webpack_public_path__ + "static/media/combat_lesson_desktop_1.486b4598.webp";